var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileWordRegular({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Differenzmenge_9",
    "data-name": "Differenzmenge 9",
    d: "M17,19H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0H17a2,2,0,0,1,2,2V17A2,2,0,0,1,17,19ZM9.48,8.252H9.5l.272,1.224.7,3.024h1.384l1.3-5.584H12.008L11.472,9.6l-.3,1.552h-.024L10.808,9.6l-.624-2.68H8.856L8.24,9.6l-.353,1.552H7.864L7.568,9.6,7.04,6.916H5.84L7.1,12.5H8.5l.7-3.024.28-1.223Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileWordRegular);
export default __webpack_public_path__ + "static/media/file-word-regular.48fec3e422305d7b7d33f6301d368f0c.svg";
export { ForwardRef as ReactComponent };